import { render } from "./OffcanvasMenu.vue?vue&type=template&id=486df4cc&scoped=true"
import script from "./OffcanvasMenu.vue?vue&type=script&lang=js"
export * from "./OffcanvasMenu.vue?vue&type=script&lang=js"

import "./OffcanvasMenu.vue?vue&type=style&index=0&id=486df4cc&scoped=true&lang=css"

import exportComponent from "/Users/unipar/Code/neo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486df4cc"]])

export default __exports__